import './tags_input.less';

import React from 'react';

import TagsInput from 'react-tagsinput';
import AutosizeInput from 'react-input-autosize';
import classNames from 'classnames';
import { SafeTipsy } from 'zoomforth_component_lib/tipsy.jsx';


const DefaultRenderTag = (props) => {
  let {tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other} = props;
  return (
    <span key={key} {...other}>
      {getTagDisplayValue(tag)}
      {!disabled &&
        <a className={classNameRemove} onClick={() => onRemove(key)} />
      }
    </span>
  );
};

const AutosizingRenderInput = ({ addTag, ...props}) => {
  let {
    value,
    disabled,
    disabledReason,
    className,
    onChange,
    ...inputProps
  } = props;

  return (
    <SafeTipsy content={disabledReason} placement="top">
      <AutosizeInput
        type='text'
        disabled={disabled}
        className={classNames(className, { disabled })}
        onChange={onChange}
        value={value}
        {...inputProps}
      />
    </SafeTipsy>
  );
};

const TagInput = (props) => {
  const {
    dark,
    // An array of tags.
    value,
    // Callback when tags change, gets three arguments tags which is the new
    // tag array, changed which is an array of the tags that have changed and
    // changedIndexes which is an array of the indexes that have changed.
    onChange,
    // Callback from the input box, gets one argument value which is the
    // content of the input box. (onChangeInput is only called if the input box
    // is controlled, for this to happen both inputValue and onChangeInput need
    // to be set)
    onChangeInput,
    // An array of key codes that add a tag, default is [9, 13] (Tab and Enter).
    addKeys,
    // A string to set a value on the input.
    currentValue,
    // Similar to currentValue but needed for controlling the input box.
    // (inputValue is only useful if you use it together with onChangeInput)
    inputValue,
    // Allow only unique tags, default is false.
    onlyUnique,
    // Validate based on callback function
    validate,
    // Allow only tags that pass this regex to be added. Default is /.*/.
    validationRegex,
    // Callback when tags are rejected through validationRegex, passing array
    // of tags as the argument.
    onValidationReject,
    // Passes the disabled prop to renderInput and renderTag, by default this
    // will "disable" the component.
    disabled,
    // If it's disabled, state the reason why for a helpful tooltip.
    disabledReason,
    // Allow limit number of tags, default is -1 for infinite.
    maxTags,
    // Add a tag if input blurs. Default false.
    addOnBlur,
    // Add a tags if HTML5 paste on input. Default false.
    addOnPaste,
    // Function that splits pasted text. Default is:
    pasteSplit,
    // An array of key codes that remove a tag, default is [8] (Backspace).
    removeKeys,
    // Specify the wrapper className. Default is react-tagsinput.
    className,
    // Specify the class to add to the wrapper when the component is focused.
    // Default is react-tagsinput--focused.
    focusedClassName,
    // Render function for every tag.
    renderTag,
    // Render function for input.
    renderInput,
    // A boolean to prevent the default submit event when adding an 'empty'
    // tag. Default: true. Set to false if you want the default submit to fire
    // when pressing enter again after adding a tag.
    preventSubmit,
    // Input placeholder will show if no tags currently exist
    placeholder,
    inputProps
  } = props;

  return (
    <TagsInput
      value={value}
      onChange={onChange}
      onChangeInput={onChangeInput}
      addKeys={addKeys}
      currentValue={currentValue}
      inputValue={inputValue}
      onlyUnique={onlyUnique}
      validate={validate}
      validationRegex={validationRegex}
      onValidationReject={onValidationReject}
      disabled={disabled}
      maxTags={maxTags}
      addOnBlur={addOnBlur}
      addOnPaste={addOnPaste}
      pasteSplit={pasteSplit}
      removeKeys={removeKeys}
      className={classNames(className, { dark, disabled })}
      focusedClassName={disabled ? '' : focusedClassName}
      renderTag={renderTag}
      renderInput={renderInput}
      preventSubmit={preventSubmit}
      inputProps={{
        disabled,
        disabledReason,
        className: 'react-tagsinput-input',
        placeholder: (value.length ? '' : placeholder || ''),
        ...inputProps
      }} />
  );
};

TagInput.defaultProps = {
  addKeys: [9, 13, 32, 186, 188], // tab, enter, space, semicolon, comma
  onlyUnique: true,
  addOnPaste: true,
  pasteSplit: data => {
    return data.replace(/[\r\n,;]/g, ' ').split(' ').map(d => d.trim());
  },
  renderTag: DefaultRenderTag,
  renderInput: AutosizingRenderInput,
  inputProps: {}
};

export default TagInput;
